import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO, FB_URL, IG_URL, WHATSAPP } from "../shared";

const SERVICES = [
  { id:"food", icon:"🍽️", title:"Order Food", sub:"Kitchen & Room Service", desc:"Fresh meals to your room, for pickup or delivery. Breakfast, lunch, dinner and midnight bites.", color:"#c8860a", href:"/order", cta:"Order Now", hours:"6AM – 2AM", badge:"Most Popular" },
  { id:"rooms", icon:"🛏️", title:"Book a Room", sub:"Stay With Us", desc:"Standard Deluxe, Super Deluxe and Executive rooms. Quiet, private and professional comfort.", color:"#9b7fd4", href:"/rooms", cta:"Book Now", hours:"Check-in 2PM", badge:null },
  { id:"cars", icon:"🚐", title:"Hire a Car", sub:"Toyota Sienna · Driver Included", desc:"Airport transfers, business trips, weddings and leisure. We beat any ongoing market price.", color:"#3aad72", href:"/carhire", cta:"Book Sienna", hours:"24/7 Available", badge:"Best Price" },
  { id:"laundry", icon:"🧺", title:"Laundry Service", sub:"In-house & Outside Pickup", desc:"Wash, dry, fold and iron. For hotel guests and outside customers with pickup.", color:"#2aab8a", href:"/laundry", cta:"Request Now", hours:"Mon – Sat", badge:null },
];

const AMENITIES = [
  ["📶","Free WiFi"],["🅿️","Free Parking"],["🍽️","Restaurant"],["🍺","VIP Bar & O Bar"],
  ["📺","Flat-screen TV"],["❄️","Air Conditioning"],["🧺","Laundry Service"],["✈️","Airport Transfers"],
];

const BOOK_SITES = [
  ["✈️","Expedia","https://expedia.com"],
  ["🌍","Booking.com","https://booking.com"],
  ["🏨","Hotels.ng","https://hotels.ng"],
  ["🦉","TripAdvisor","https://tripadvisor.com"],
];

const NAV_ITEMS = [
  ["🍽️ Order Food","/order"],
  ["🛏️ Book Room","/rooms"],
  ["🚐 Car Hire","/carhire"],
  ["🧺 Laundry","/laundry"],
];

const FOOTER_SERVICES = [
  ["Order Food","/order"],
  ["Book a Room","/rooms"],
  ["Hire a Car","/carhire"],
  ["Laundry","/laundry"],
];

const GOOD_TO_KNOW = [
  ["🕑","Check-in from 2:00 PM"],
  ["🕛","Check-out by 12:00 noon"],
  ["🔄","Free cancellation within 48hrs"],
  ["🚭","Non-smoking rooms"],
  ["📶","Free WiFi throughout"],
  ["🅿️","Free parking on-site"],
];

const STATS = [
  ["🛏️","11","Rooms"],
  ["⭐","4+","Star Service"],
  ["📍","Awka","City Centre"],
];

export default function HomePage() {
  const navigate = useNavigate();
  const [hov, setHov] = useState(null);

  return (
    <div style={{ fontFamily:"Palatino Linotype,Book Antiqua,Palatino,Georgia,serif", background:"#08070a", minHeight:"100vh", color:"#f0e4c8" }}>
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0}
        @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{background-position:-200% center}100%{background-position:200% center}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}
        .sc{transition:transform 0.2s,box-shadow 0.2s;cursor:pointer}
        .sc:hover{transform:translateY(-4px)}
        .nl{transition:opacity 0.16s}
        .nl:hover{opacity:0.75}
        .bs{transition:all 0.16s}
        .bs:hover{transform:translateY(-2px);opacity:0.85}
        .am{transition:all 0.16s}
        .am:hover{border-color:#c8860a55!important;background:#1e1600!important}
        @media(max-width:768px){
          .dnav{display:none!important}
          .hg{grid-template-columns:1fr!important;text-align:center}
          .sg{grid-template-columns:1fr!important}
          .ag{grid-template-columns:1fr 1fr!important}
          .bg{grid-template-columns:1fr 1fr!important}
          .fg{grid-template-columns:1fr!important}
        }
        @media(min-width:769px){
          .sg{grid-template-columns:1fr 1fr!important}
          .ag{grid-template-columns:repeat(4,1fr)!important}
          .bg{grid-template-columns:repeat(4,1fr)!important}
          .fg{grid-template-columns:repeat(3,1fr)!important}
        }
      `}</style>

      {/* HEADER */}
      <header style={{ background:"#0c0a10", borderBottom:"1px solid #1e1a28", padding:"0 32px", display:"flex", alignItems:"center", justifyContent:"space-between", height:72, position:"sticky", top:0, zIndex:100 }}>
        <img src={LOGO} style={{ height:50, objectFit:"contain" }} alt="The 401 Hotel & Suites Ltd" />
        <nav className="dnav" style={{ display:"flex", gap:28, alignItems:"center" }}>
          {NAV_ITEMS.map(([label, path]) => (
            <span key={label} className="nl" onClick={() => navigate(path)}
              style={{ color:"#c8a060", fontSize:15, letterSpacing:1, cursor:"pointer", fontWeight:600 }}>
              {label}
            </span>
          ))}
        </nav>
        <a href={"https://wa.me/" + WHATSAPP} target="_blank" rel="noreferrer"
          style={{ background:"#25D366", borderRadius:24, padding:"10px 22px", color:"#fff", fontSize:14, fontWeight:"bold", textDecoration:"none", display:"flex", alignItems:"center", gap:6 }}>
          📲 <span className="dnav" style={{display:"inline"}}>WhatsApp Us</span>
        </a>
      </header>

      {/* HERO */}
      <section style={{ background:"linear-gradient(135deg,#120d1a 0%,#0a0810 50%,#08070a 100%)", padding:"72px 40px", borderBottom:"1px solid #1e1a28" }}>
        <div className="hg" style={{ maxWidth:1200, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:60, alignItems:"center" }}>
          <div style={{ animation:"fadeUp 0.7s ease both" }}>
            <div style={{ display:"inline-block", border:"1px solid #c8860a44", color:"#c8860a", padding:"4px 16px", borderRadius:20, fontSize:10, letterSpacing:3, marginBottom:24 }}>
              AWKA · ANAMBRA STATE · NIGERIA
            </div>
            <h1 style={{ fontSize:"clamp(30px,5vw,54px)", fontWeight:"bold", color:"#f0e4c8", lineHeight:1.1, marginBottom:14 }}>
              The 401 Hotel<br/>
              <span style={{ background:"linear-gradient(90deg,#c8860a,#e8c060,#c8860a)", backgroundSize:"200% auto", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text", animation:"shimmer 3s linear infinite" }}>
                & Suites Ltd
              </span>
            </h1>
            <p style={{ fontSize:18, color:"#c8a040", fontStyle:"italic", marginBottom:10, letterSpacing:1 }}>Quiet. Private. Professional. Serenity.</p>
            <p style={{ fontSize:14, color:"#6a5a40", lineHeight:1.8, marginBottom:28, maxWidth:420 }}>
              Awka's finest boutique hotel — where every detail speaks of comfort, privacy and class.
            </p>
            <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
              <button onClick={() => navigate("/rooms")}
                style={{ background:"linear-gradient(135deg,#c8860a,#e8a020)", border:"none", borderRadius:12, padding:"14px 28px", color:"#08070a", fontSize:14, fontWeight:"bold", cursor:"pointer", fontFamily:"inherit" }}>
                Book a Room →
              </button>
              <button onClick={() => navigate("/order")}
                style={{ background:"transparent", border:"1px solid #c8860a55", borderRadius:12, padding:"14px 28px", color:"#c8860a", fontSize:14, cursor:"pointer", fontFamily:"inherit" }}>
                Order Food
              </button>
            </div>
          </div>
          <div style={{ animation:"fadeUp 0.7s ease 0.2s both" }}>
            <div style={{ background:"linear-gradient(135deg,#1a1420,#0f0c16)", border:"1px solid #2a2035", borderRadius:24, padding:32, textAlign:"center" }}>
              <img src={LOGO} style={{ height:110, objectFit:"contain", marginBottom:20, animation:"float 4s ease-in-out infinite" }} alt="The 401 Hotel" />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:14 }}>
                {STATS.map(([ic, v, l]) => (
                  <div key={l} style={{ background:"#08070a", borderRadius:12, padding:"12px 6px", border:"1px solid #1e1a28" }}>
                    <div style={{fontSize:18,marginBottom:4}}>{ic}</div>
                    <div style={{fontSize:16,fontWeight:"bold",color:"#c8860a"}}>{v}</div>
                    <div style={{fontSize:10,color:"#6a5a40",letterSpacing:1}}>{l}</div>
                  </div>
                ))}
              </div>
              <div style={{ background:"#c8860a15", borderRadius:10, padding:12, border:"1px solid #c8860a33" }}>
                <div style={{fontSize:11,color:"#c8860a",letterSpacing:2}}>FREE CANCELLATION · FREE WIFI · FREE PARKING</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section style={{ padding:"60px 32px", maxWidth:1200, margin:"0 auto" }}>
        <div style={{ textAlign:"center", marginBottom:40 }}>
          <div style={{fontSize:10,letterSpacing:4,color:"#c8860a",marginBottom:10}}>OUR SERVICES</div>
          <h2 style={{fontSize:"clamp(22px,3vw,34px)",fontWeight:"bold",color:"#f0e4c8"}}>Everything You Need</h2>
          <p style={{fontSize:13,color:"#6a5a40",marginTop:6}}>Order, book and request from your phone — WhatsApp notification to our team instantly</p>
        </div>
        <div className="sg" style={{ display:"grid", gap:16 }}>
          {SERVICES.map((s, i) => (
            <div key={s.id} className="sc"
              onClick={() => navigate(s.href)}
              onMouseEnter={() => setHov(s.id)}
              onMouseLeave={() => setHov(null)}
              style={{ background: hov===s.id ? s.color+"18" : "#111018", border:`1.5px solid ${hov===s.id ? s.color+"55" : "#1e1a28"}`, borderRadius:20, padding:24, animation:`fadeUp 0.5s ease ${i*0.1+0.3}s both`, transition:"all 0.2s" }}>
              <div style={{display:"flex",gap:18,alignItems:"flex-start"}}>
                <div style={{width:56,height:56,borderRadius:16,background:s.color+"18",border:`1px solid ${s.color}33`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,flexShrink:0}}>{s.icon}</div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <h3 style={{fontSize:17,fontWeight:"bold",color:"#f0e4c8"}}>{s.title}</h3>
                    {s.badge && <span style={{fontSize:9,background:s.color+"22",border:`1px solid ${s.color}44`,color:s.color,borderRadius:6,padding:"2px 8px",letterSpacing:1}}>{s.badge}</span>}
                  </div>
                  <div style={{fontSize:11,color:s.color,letterSpacing:1,marginBottom:8}}>{s.sub}</div>
                  <p style={{fontSize:13,color:"#6a5a40",lineHeight:1.7,marginBottom:14}}>{s.desc}</p>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <span style={{fontSize:11,color:"#4a3a28"}}>🕐 {s.hours}</span>
                    <span style={{background:s.color,borderRadius:10,padding:"8px 18px",color:"#08070a",fontSize:12,fontWeight:"bold"}}>{s.cta} →</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* AMENITIES */}
      <section style={{ background:"#0c0a10", borderTop:"1px solid #1e1a28", borderBottom:"1px solid #1e1a28", padding:"52px 32px" }}>
        <div style={{maxWidth:1200,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:32}}>
            <div style={{fontSize:10,letterSpacing:4,color:"#c8860a",marginBottom:10}}>HOTEL FEATURES</div>
            <h2 style={{fontSize:"clamp(20px,3vw,30px)",fontWeight:"bold",color:"#f0e4c8"}}>Everything Included</h2>
          </div>
          <div className="ag" style={{display:"grid",gap:12}}>
            {AMENITIES.map(([ic, lb]) => (
              <div key={lb} className="am" style={{background:"#08070a",border:"1px solid #1e1a28",borderRadius:14,padding:"16px 18px",display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontSize:22}}>{ic}</span>
                <span style={{fontSize:13,color:"#8a7a60"}}>{lb}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INFO */}
      <section style={{padding:"52px 32px",maxWidth:1200,margin:"0 auto"}}>
        <div className="fg" style={{display:"grid",gap:18}}>
          <div style={{background:"#111018",border:"1px solid #1e1a28",borderRadius:20,padding:26}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#c8860a",marginBottom:14}}>FIND US</div>
            <div style={{fontSize:26,marginBottom:10}}>📍</div>
            <div style={{fontSize:15,fontWeight:"bold",color:"#f0e4c8",marginBottom:6}}>Plot A/39 Iyiagu Estate</div>
            <div style={{fontSize:13,color:"#6a5a40",lineHeight:1.8,marginBottom:14}}>Off Abakaliki Street, Awka<br/>Anambra State, Nigeria</div>
            <a href="https://maps.google.com/?q=The+401+Hotel+Suites+Awka" target="_blank" rel="noreferrer"
              style={{display:"inline-block",background:"#c8860a18",border:"1px solid #c8860a33",borderRadius:8,padding:"7px 14px",color:"#c8860a",fontSize:12,textDecoration:"none"}}>
              🗺️ Open in Google Maps
            </a>
          </div>
          <div style={{background:"#111018",border:"1px solid #1e1a28",borderRadius:20,padding:26}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#c8860a",marginBottom:14}}>GOOD TO KNOW</div>
            {GOOD_TO_KNOW.map(([ic, tx]) => (
              <div key={tx} style={{display:"flex",gap:10,marginBottom:10,alignItems:"center"}}>
                <span style={{fontSize:16}}>{ic}</span>
                <span style={{fontSize:13,color:"#6a5a40"}}>{tx}</span>
              </div>
            ))}
          </div>
          <div style={{background:"#111018",border:"1px solid #1e1a28",borderRadius:20,padding:26}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#c8860a",marginBottom:14}}>ALSO BOOK ON</div>
            <div className="bg" style={{display:"grid",gap:10,marginBottom:14}}>
              {BOOK_SITES.map(([ic, nm, url]) => (
                <a key={nm} href={url} target="_blank" rel="noreferrer" className="bs"
                  style={{background:"#08070a",border:"1px solid #1e1a28",borderRadius:12,padding:"12px 8px",textAlign:"center",textDecoration:"none"}}>
                  <div style={{fontSize:20,marginBottom:5}}>{ic}</div>
                  <div style={{fontSize:11,color:"#f0e4c8",fontWeight:"bold"}}>{nm}</div>
                </a>
              ))}
            </div>
            <div style={{fontSize:11,color:"#4a3a28",textAlign:"center"}}>Or book directly with us for the best rate</div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{background:"#0c0a10",borderTop:"1px solid #1e1a28",padding:"40px 32px 24px"}}>
        <div style={{maxWidth:1200,margin:"0 auto"}}>
          <div className="fg" style={{display:"grid",gap:32,marginBottom:32}}>
            <div>
              <img src={LOGO} style={{height:52,objectFit:"contain",marginBottom:14}} alt="The 401 Hotel" />
              <p style={{fontSize:13,color:"#4a3a28",lineHeight:1.8,maxWidth:280}}>Quiet. Private. Professional. Serenity.<br/>Awka's finest boutique hotel.</p>
              <div style={{display:"flex",gap:10,marginTop:14,flexWrap:"wrap"}}>
                <a href={IG_URL} target="_blank" rel="noreferrer" style={{background:"#1e1a28",borderRadius:8,padding:"8px 14px",color:"#c8860a",fontSize:13,textDecoration:"none"}}>📸 @the401hotel</a>
                <a href={FB_URL} target="_blank" rel="noreferrer" style={{background:"#1e1a28",borderRadius:8,padding:"8px 14px",color:"#c8860a",fontSize:13,textDecoration:"none"}}>📘 Facebook</a>
              </div>
            </div>
            <div>
              <div style={{fontSize:10,letterSpacing:3,color:"#c8860a",marginBottom:14}}>SERVICES</div>
              {FOOTER_SERVICES.map(([label, path]) => (
                <div key={label} onClick={() => navigate(path)}
                  style={{fontSize:13,color:"#4a3a28",marginBottom:10,cursor:"pointer"}}
                  onMouseEnter={e => e.target.style.color="#c8860a"}
                  onMouseLeave={e => e.target.style.color="#4a3a28"}>
                  {label}
                </div>
              ))}
            </div>
            <div>
              <div style={{fontSize:10,letterSpacing:3,color:"#c8860a",marginBottom:14}}>CONTACT</div>
              <div style={{fontSize:13,color:"#4a3a28",lineHeight:2}}>
                <div>📞 +234 806 499 5073</div>
                <div>📍 Iyiagu Estate, Awka</div>
                <div>🌐 the401hotels.com</div>
              </div>
              <a href={"https://wa.me/" + WHATSAPP} target="_blank" rel="noreferrer"
                style={{display:"inline-block",marginTop:12,background:"#25D36618",border:"1px solid #25D36644",borderRadius:8,padding:"8px 16px",color:"#25D366",fontSize:12,textDecoration:"none"}}>
                📲 Chat on WhatsApp
              </a>
            </div>
          </div>
          <div style={{borderTop:"1px solid #1e1a28",paddingTop:18,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
            <div style={{fontSize:11,color:"#2a2018"}}>© 2026 The 401 Hotel & Suites Ltd. All rights reserved.</div>
            <div style={{fontSize:11,color:"#2a2018"}}>Quiet. Private. Professional. Serenity.</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
